import Footer from "../../Shared/Layout/Footer"
import "../../../Styles/main.scss"
import AuthPageDescription from "../../Shared/Primitive/AuthPageDescription"
import AuthPageImage from "../../Shared/Primitive/AuthPageImage"
import SignupForm from "./SignupForm"
import { LogoIconMobile } from "../../Shared/Components/SvgIcons"
import { Capacitor } from "@capacitor/core"

function SignupScreen() {
    const isNativeApp = Capacitor.isNativePlatform()

    return (
        <>
            <div className={`auth-layout ${isNativeApp ? "auth-layout--native" : ""}`}>
                <div className="auth-layout__main-container">
                    {!isNativeApp && (
                        <div className="left-panel">
                            <div className="left-panel__logo">
                                {" "}
                                <LogoIconMobile />
                            </div>
                            <div className="left-panel__description">
                                <AuthPageDescription />
                            </div>
                            <div className="edusiia-image">
                            <AuthPageImage />
                        </div>
                        </div>
                    )}
                    <div className="right-panel">
                        {isNativeApp ? (
                            <div className="right-panel__native-logo">
                                <LogoIconMobile />
                            </div>
                        ) : (
                            <div className="right-panel__edusiia-image">
                                <AuthPageImage />
                            </div>
                        )}
                        <div className="right-panel__signup-form">
                            <SignupForm />
                        </div>
                    </div>
                </div>
                {!isNativeApp && <Footer landingPageFooter={true} />}
            </div>
        </>
    )
}

export default SignupScreen
